import * as React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 28.9,
  height: 17.85,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 1.275,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(10.88px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#4d4d4d',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#E9E9EA',
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '5px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#ffff',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: '#E9E9EA',
      opacity: 1,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 14.96,
    height: 14.96,
  },
  '& .MuiSwitch-track': {
    borderRadius: 8.925,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['backgroundColor'], {
      duration: 500,
    }),
  },
}));

export default IOSSwitch;
